import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


import home from '@/module/home/router'
import Login from '@/module/login/router'
import operatorJoin from '@/module/memberCenter/router/operatorJoin'
import errorPage from '@/module/error-page/router'

export const constantRoutes = [
  ...home,
  ...Login,
  ...operatorJoin,
  ...errorPage
]


/**
 * asyncRoutes
 */
import monitoringCenter from '@/module/monitoringCenter/router'
import operatingCenter from '@/module/operatingCenter/router'
import possessionCenter from '@/module/possessionCenter/router'
import systemManagement from '@/module/systemManagement/router'
import resourceCenter from '@/module/resourceCenter/router'
import maintenanceCenter from '@/module/maintenanceCenter/router'
import marketingCenter from '@/module/marketingCenter/router'
import memberCenter from '@/module/memberCenter/router'
export const asyncRoutes = [
  ...monitoringCenter,
  {
    path: '/',
    redirect: '/home-page',
    hidden: true
  },
  ...operatingCenter,
  ...marketingCenter,
  ...memberCenter,
  ...possessionCenter,
  ...resourceCenter,
  ...maintenanceCenter,
  ...systemManagement,
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})


const router = createRouter()

// 解决Loading chunk 30 failed报错问题
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
// 避免路由重复加入
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
export default router



// WEBPACK FOOTER //
// ./src/base/router/index.js